import { forwardRef } from "react";
function SvgRawNestedIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        stroke="#1D1D1D"
        strokeLinejoin="round"
        d="M8 6v11a3 3 0 0 0 3 3h11"
      />
      <path
        fill="#1D1D1D"
        fillRule="evenodd"
        d="m25 20-6 4v-8l6 4Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawNestedIcon);
export default ForwardRef;
